<template>
   <div>
      <el-form
         :model="verifyDoc"
         ref="phone"
         class="checkout-form dashboard-form pl-1 pr-1 pt-1"
         size="small"
         v-loading="loading.save || loading.user"
      >
         <p><strong>Documento pessoal</strong></p>
         <p class="text-muted">ATENÇÃO: Caso seja arquivo único, envie apenas na opção Frente e desconsidere o Verso.</p>

         <!--  Radio Tipo de documento -->
         <el-form-item class="mb-0" label="Tipo de documento">
            <el-radio-group v-model="verifyDoc.docType" class="text-uppercase" style="margin-top: -12px">
               <el-radio label="rg" class="mr-3"></el-radio>
               <el-radio label="cnh" class="mr-3"></el-radio>
               <el-radio label="passaporte"></el-radio>
            </el-radio-group>
         </el-form-item>

         <!--  Uploads -->
         <el-row :gutter="20" class="upload-docs">
            <el-col :span="24" :md="11" class="mb-3">

               <!--  Frente -->
               <p class="text-left"><strong>Frente</strong></p>
               <div v-if="!documents.personalDocFront.filename">
                  <Uploader
                     :nameSpace="`docUser/${verifyDoc.docType}/frente`"
                     :userId="userId"
                     @file="f => handleSaveFile(f, 'documento-pessoal-frente')"
                  ></Uploader>
               </div>
               <div v-else>
                  <div
                     @click="openDoc(documents.personalDocFront)"
                     class="link-doc"
                     :class="`
                     ${documents.personalDocFront.status === 1 ? 'text-blue' : ''}
                     ${documents.personalDocFront.status === 2 ? 'text-primary' : ''}
                     ${documents.personalDocFront.status === 3 ? 'text-danger' : ''}
                     `"
                  >
                     <i class="el-icon-document icon-doc-sent"></i>
                     Documento enviando em   {{ documents.personalDocFront.createdAt | moment('D [de] MMMM [de] YYYY [às] H:mm') }}
                     <div>
                        <el-tag
                           class="text-uppercase font-weight-bold mt-2"
                           size="mini"
                           :type="documents.personalDocFront.status === 1 ? 'blue' :
                               documents.personalDocFront.status === 2 ? 'primary' :
                              documents.personalDocFront.status === 3 ? 'danger' : ''"
                           effect="dark">
                           <span v-if="documents.personalDocFront.status === 1">
                              <i class="el-icon-tickets"></i> Em análise
                           </span>
                           <span v-if="documents.personalDocFront.status === 2">
                              <i class="el-icon-document-checked"></i> Aprovado
                           </span>
                           <span v-if="documents.personalDocFront.status === 3">
                              <i class="el-icon-document-delete"></i> Reprovado
                           </span>
                        </el-tag>
                     </div>
                  </div>
                  <hr
                     v-if="currentUser.user.type === 'master' && documents.personalDocFront.status === 1"
                     style="margin: 14px 0 6px;">
                  <div
                     v-if="currentUser.user.type === 'master' && documents.personalDocFront.status === 1"
                     class="d-flex justify-content-center">
                        <el-button
                           @click="() => approveDocument('personalDocFront-approve', documents.personalDocFront._id, 2)
                           "
                           :loading="loading.changeStatusDoc.personalDocFront.approve"
                           type="success"
                           size="mini"
                           class="font-weight-bold py-0 mt-2 mr-3"
                        >
                           Aprovar
                        </el-button>
                        <el-button
                           @click="() => approveDocument('personalDocFront-disapprove', documents.personalDocFront._id, 3)"
                           :loading="loading.changeStatusDoc.personalDocFront.disapprove"
                           type="danger"
                           size="mini"
                           class="font-weight-bold py-0 mt-2"
                        >
                           Rejeitar
                        </el-button>
                     </div>
                  <div v-if="documents.personalDocFront.status === 3" class="mt-3">
                        <Uploader
                           textButton="Enviar arquivo novamente"
                           :nameSpace="`docUser/${verifyDoc.docType}/frente`"
                           :userId="userId"
                           @file="f => handleSaveFile(f, 'documento-pessoal-frente')"
                        >
                        </Uploader>
                     </div>
               </div>
            </el-col>
            <el-col :span="1" :sm="1" class="d-none d-lg-block">
               <el-divider direction="vertical"></el-divider>
            </el-col>

            <!--  Verso -->
            <el-col :span="24" :md="11">
               <p class="text-left"><strong>Verso</strong></p>
               <div v-if="!documents.personalDocBack.filename">
                  <Uploader
                     :nameSpace="`docUser/${verifyDoc.docType}/verso`"
                     :userId="userId"
                     @file="f => handleSaveFile(f, 'documento-pessoal-verso')"
                  ></Uploader>
               </div>
               <div v-else>
                  <div
                     @click="openDoc(documents.personalDocBack)"
                     class="link-doc"
                     :class="`
                     ${documents.personalDocBack.status === 1 ? 'text-blue' : ''}
                     ${documents.personalDocBack.status === 2 ? 'text-primary' : ''}
                     ${documents.personalDocBack.status === 3 ? 'text-danger' : ''}
                     `"
                  >
                     <i class="el-icon-document icon-doc-sent"></i>
                     Documento enviando em   {{ documents.personalDocBack.createdAt | moment('D [de] MMMM [de] YYYY [às] H:mm') }}
                     <div>
                        <el-tag
                           class="text-uppercase font-weight-bold mt-2"
                           size="mini"
                           :type="documents.personalDocBack.status === 1 ? 'blue' :
                         documents.personalDocBack.status === 2 ? 'primary' :
                        documents.personalDocBack.status === 3 ? 'danger' : ''"
                           effect="dark">
                           <span v-if="documents.personalDocBack.status === 1">
                              <i class="el-icon-tickets"></i> Em análise
                           </span>
                           <span v-if="documents.personalDocBack.status === 2">
                              <i class="el-icon-document-checked"></i> Aprovado
                           </span>
                           <span v-if="documents.personalDocBack.status === 3">
                              <i class="el-icon-document-delete"></i> Reprovado
                           </span>
                        </el-tag>
                     </div>
                  </div>
                  <hr
                     v-if="currentUser.user.type === 'master' && documents.personalDocBack.status === 1"
                     style="margin: 14px 0 6px;">
                  <div
                     v-if="currentUser.user.type === 'master' &&  documents.personalDocBack.status === 1"
                     class="d-block">
                        <el-button
                           @click="() => approveDocument('personalDocBack-approve', documents.personalDocBack._id, 2)"
                           :loading="loading.changeStatusDoc.personalDocBack.approve"
                           type="success"
                           size="mini"
                           class="font-weight-bold py-0 mt-2"
                        >
                           Aprovar
                        </el-button>
                        <el-button
                           @click="() => approveDocument('personalDocBack-disapprove', documents.personalDocBack._id, 3)"
                           :loading="loading.changeStatusDoc.personalDocBack.disapprove"
                           type="danger"
                           size="mini"
                           class="font-weight-bold py-0 mt-2 mr-3"
                        >
                           Rejeitar
                        </el-button>
                     </div>
                  <div v-if="documents.personalDocBack.status === 3" class="mt-3">
                        <Uploader
                           textButton="Enviar arquivo novamente"
                           :nameSpace="`docUser/${verifyDoc.docType}/verso`"
                           :userId="userId"
                           @file="f => handleSaveFile(f, 'documento-pessoal-verso')"
                        >
                        </Uploader>
                     </div>
               </div>
            </el-col>
         </el-row>
         <div class="el-upload__tip" style="opacity: 0.5"><p>Arquivos no formato jpg/png/pdf e com tamanho máximo de 5mb</p></div>

         <hr>

         <p><strong>Comprovante de residência</strong></p>

         <!--  Radio Tipo de documento -->
         <div class="tipo-de-doc-pessoal">
            <el-form-item class="mb-0" label="Tipo de documento">
               <el-radio-group class="text-capitalize mt-0" v-model="verifyDoc.addressDocType">
                  <el-radio label="água" class="mr-3"></el-radio>
                  <el-radio label="luz" class="mr-3"></el-radio>
                  <el-radio label="telefone" class="mr-3"></el-radio>
                  <el-radio label="outros"></el-radio>
               </el-radio-group>
            </el-form-item>
         </div>


         <!--  Uploads -->
         <el-row :gutter="20" class="upload-docs">
            <el-col :span="24" class="mb-3">

               <!--  Frente -->
               <p class="text-left"><strong>Frente</strong></p>
               <div v-if="!documents.addressDoc.filename">
                  <Uploader
                     :nameSpace="`docUser/${verifyDoc.addressDocType}`"
                     :userId="userId"
                     @file="f => handleSaveFile(f, 'comprovante-residencia')"
                  >
                  </Uploader>
               </div>
               <div v-else>
                  <div
                     @click="openDoc(documents.addressDoc)"
                     class="link-doc"
                     :class="`
                     ${documents.addressDoc.status === 1 ? 'text-blue' : ''}
                     ${documents.addressDoc.status === 2 ? 'text-primary' : ''}
                     ${documents.addressDoc.status === 3 ? 'text-danger' : ''}
                     `"
                  >
                     <i class="el-icon-document icon-doc-sent"></i>
                     Comprovante enviando em   {{ documents.addressDoc.createdAt | moment('D [de] MMMM [de] YYYY [às] H:mm') }}
                     <div>
                        <el-tag
                           class="text-uppercase font-weight-bold mt-2"
                           size="mini"
                           :type="documents.addressDoc.status === 1 ? 'blue' :
                         documents.addressDoc.status === 2 ? 'primary' :
                        documents.addressDoc.status === 3 ? 'danger' : ''"
                           effect="dark">
                           <span v-if="documents.addressDoc.status === 1">
                              <i class="el-icon-tickets"></i> Em análise
                           </span>
                           <span v-if="documents.addressDoc.status === 2">
                              <i class="el-icon-document-checked"></i> Aprovado
                           </span>
                           <span v-if="documents.addressDoc.status === 3">
                              <i class="el-icon-document-delete"></i> Reprovado
                           </span>
                        </el-tag>
                     </div>
                  </div>
                  <hr
                     v-if="currentUser.user.type === 'master' && documents.addressDoc.status === 1"
                     style="margin: 14px 0 6px;">
                  <div
                     v-if="currentUser.user.type === 'master' && documents.addressDoc.status === 1"
                     class="d-block">
                        <el-button
                           @click="() => approveDocument('addressDoc-approve', documents.addressDoc._id, 2)"
                           :loading="loading.changeStatusDoc.addressDoc.approve"
                           type="success"
                           size="mini"
                           class="font-weight-bold py-0 mt-2"
                        >
                           Aprovar
                        </el-button>
                        <el-button
                           @click="() => approveDocument('addressDoc-disapprove', documents.addressDoc._id, 3)"
                           :loading="loading.changeStatusDoc.addressDoc.disapprove"
                           type="danger"
                           size="mini"
                           class="font-weight-bold py-0 mt-2 mr-3"
                        >
                           Rejeitar
                        </el-button>
                     </div>
                  <div v-if="documents.addressDoc.status === 3" class="mt-3">
                        <Uploader
                           textButton="Enviar arquivo novamente"
                           :nameSpace="`docUser/${verifyDoc.addressDocType}`"
                           :userId="userId"
                           @file="f => handleSaveFile(f, 'comprovante-residencia')"
                        >
                        </Uploader>
                     </div>
               </div>

            </el-col>
         </el-row>
         <div class="el-upload__tip" style="opacity: 0.5"><p>Arquivos no formato jpg/png/pdf e com tamanho máximo de 5mb</p></div>

      </el-form>
   </div>
</template>

<script>
import Uploader from "@/components/Uploader";
import BikeImg from "@/helpers/GetBikeCover";
import UserService from "../services/user.service";

export default {
   name: 'VerifyDoc',
   components: {
      Uploader
   },
   props: {
      verifiedPhone: null,
      userId: String,
   },
   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         loading: {
            save: false,
            user: true,
            changeStatusDoc: {
               personalDocFront: {
                  approve: false,
                  disapprove: false
               },
               personalDocBack: {
                  approve: false,
                  disapprove: false
               },
               addressDoc: {
                  approve: false,
                  disapprove: false
               },
            }
         },
         verifyDoc: {
            docType: 'rg',
            addressDocType: 'água'
         },
         documents: {
            personalDocFront: {},
            personalDocBack: {},
            addressDoc: {},
         },
         nameSpace: ''
      }
   },
   mounted() {
      this.checkDocs()
   },
   methods: {
      getCover(uri) {
         return BikeImg.getCover(uri);
      },

      openDoc(doc) {
         const url = this.getCover(doc)
         window.open(url, '_blank')
      },

      async  checkDocs(documents) {
         return new Promise((resolve) => {
            setTimeout(() => {
               this.loading.user = false
               if(this.userData?.documents.length) {
                  const docs = documents || this.userData?.documents
                  docs.map(doc => {
                     if (doc.nameSpace === 'docUser/rg/frente' ||
                        doc.nameSpace === 'docUser/cnh/frente' ||
                        doc.nameSpace === 'docUser/passaporte/frente') {
                        this.verifyDoc.docType = doc.nameSpace.replace("docUser/", "").replace("/frente", "")
                        this.documents.personalDocFront = doc
                     }

                     if (doc.nameSpace === 'docUser/rg/verso' ||
                        doc.nameSpace === 'docUser/cnh/verso' ||
                        doc.nameSpace === 'docUser/passaporte/verso') {
                        this.documents.personalDocBack = doc
                     }

                     if (doc.nameSpace === 'docUser/água' ||
                        doc.nameSpace === 'docUser/luz' ||
                        doc.nameSpace === 'docUser/telefone' ||
                        doc.nameSpace === 'docUser/outros'
                     ) {
                        this.verifyDoc.addressDocType = doc.nameSpace.replace("docUser/", "")
                        this.documents.addressDoc = doc
                     }
                  })
                  resolve(true);
               }
            }, 2000)
         });

      },

      handleSaveFile(f, nameSpace) {
         switch (nameSpace) {
            case 'documento-pessoal-frente':
               this.documents.personalDocFront = f
               this.documents.personalDocFront.status = 1
               break;
            case 'documento-pessoal-verso':
               this.documents.personalDocBack = f
               this.documents.personalDocBack.status = 1
               break;
            case 'comprovante-residencia':
               this.documents.addressDoc = f
               this.documents.addressDoc.status = 1
               break;
         }
      },

      handleDisableLoadingBtns() {
         this.loading.changeStatusDoc.personalDocFront.approve = false
         this.loading.changeStatusDoc.personalDocFront.disapprove = false
         this.loading.changeStatusDoc.personalDocBack.approve = false
         this.loading.changeStatusDoc.personalDocBack.disapprove = false
         this.loading.changeStatusDoc.addressDoc.approve = false
         this.loading.changeStatusDoc.addressDoc.disapprove = false
      },

      async approveDocument(docType, docId, status) {
         switch (docType) {
            case 'personalDocFront-approve':
               this.nameSpace = 'Documento pessoal (frente)'
               this.loading.changeStatusDoc.personalDocFront.approve = true
               break
            case 'personalDocFront-disapprove':
               this.nameSpace = 'Documento pessoal (frente)'
               this.loading.changeStatusDoc.personalDocFront.disapprove = true
               break
            case 'personalDocBack-approve':
               this.nameSpace = 'Documento pessoal (verso)'
               this.loading.changeStatusDoc.personalDocBack.approve = true
               break
            case 'personalDocBack-disapprove':
               this.nameSpace = 'Documento pessoal (verso)'
               this.loading.changeStatusDoc.personalDocBack.disapprove = true
               break
            case 'addressDoc-approve':
               this.nameSpace = 'Comprovante de residência'
               this.loading.changeStatusDoc.addressDoc.approve = true
               break
            case 'addressDoc-disapprove':
               this.nameSpace = 'Comprovante de residência'
               this.loading.changeStatusDoc.addressDoc.disapprove = true
               break
         }

         await UserService.approveDocument(docId, status, this.nameSpace)
            .then(res => {
               this.checkDocs(res.data.documents)
                  .finally(async () => {
                     this.handleDisableLoadingBtns()
                     this.$message({
                        message: res.data.message,
                        type: 'success'
                     });
                     await this.getUser()
                  })
            })
      },
      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user.data
      }
   },
}
</script>

<style lang="scss">
   .upload-docs {
      .link-doc {
         cursor: pointer;
         line-height: 21px;
         text-align: center;
      }
      .el-upload {
         width: 100%;
      }

      .el-divider--vertical {
         height: 3em;
         margin: 35px 8px 0;
      }
      .icon-doc-sent {
         display: block;
         font-size: 30px;
         margin-bottom: 6px;
      }
   }
   .tipo-de-doc-pessoal {
      .el-form-item__label {
         display: block;
         width: 100%;
         text-align: left;
      }
   }
</style>
